import { Image } from '@chakra-ui/react';

import { getCardBrandDisplayName } from '../../utils/getCardBrandDisplayName';
import americanExpress from '../../assets/icons/cardbrands/amex.svg';
import discover from '../../assets/icons/cardbrands/discover.svg';
import diners from '../../assets/icons/cardbrands/diners.svg';
import jcb from '../../assets/icons/cardbrands/jcb.svg';
import masterCard from '../../assets/icons/cardbrands/mastercard.svg';
import visa from '../../assets/icons/cardbrands/visa.svg';
import dankort from '../../assets/icons/cardbrands/dankort.svg';
import eurocard from '../../assets/icons/cardbrands/eurocard.svg';
import hiper from '../../assets/icons/cardbrands/hiper.svg';
import maestro from '../../assets/icons/cardbrands/maestro.svg';
import unionPay from '../../assets/icons/cardbrands/unionpay.svg';
import unknown from '../../assets/icons/cardbrands/default.svg';

export type TokenexBrand =
  | 'americanExpress'
  | 'dankort'
  | 'diners'
  | 'discover'
  | 'eurocard'
  | 'hiper'
  | 'jcb'
  | 'maestro'
  | 'masterCard'
  | 'unionPay'
  | 'visa'
  | 'unknown';

const BrandIcons: Record<TokenexBrand, any> = {
  americanExpress,
  dankort,
  diners,
  discover,
  eurocard,
  hiper,
  jcb,
  maestro,
  masterCard,
  unionPay,
  visa,
  unknown,
};

export type CardBrandIconProps = {
  brand?: TokenexBrand;
};

export const CardBrandIcon = ({ brand }: CardBrandIconProps) => {
  const cardBrandDisplayName = getCardBrandDisplayName(brand);
  return (
    <Image
      opacity="1"
      paddingTop="3px"
      width="28px"
      src={BrandIcons[brand || 'unknown']}
      {...(cardBrandDisplayName.toLowerCase() !== 'unknown'
        ? { title: cardBrandDisplayName }
        : {})}
      data-testid="cardbrand-icon"
    />
  );
};
